<script lang="ts">
export default {
  name: 'Checkbox',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    modelValue?: boolean;
    label?: string;
    disabled?: boolean;
    indeterminate?: boolean;
    id?: string;
    class?: string;
  }>(),
  {
    disabled: false,
    indeterminate: false,
  }
);

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
}>();

const checkboxId = computed(() => props.id || `checkbox-${Math.random().toString(36).slice(2, 11)}`);

const handleChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit('update:modelValue', target.checked);
};
</script>

<template>
  <div :class="['tw:form-control', props.class]">
    <label class="tw:label tw:cursor-pointer tw:flex tw:items-center tw:justify-start tw:gap-2">
      <input
        :id="checkboxId"
        type="checkbox"
        class="tw:checkbox"
        :class="{ 'tw:checkbox-disabled': disabled }"
        :checked="modelValue"
        :disabled="disabled"
        :indeterminate="indeterminate"
        @change="handleChange"
      />
      <span v-if="label" class="tw:label-text tw:text-sm">{{ label }}</span>
    </label>
  </div>
</template>
